export function currencyReducer(
	state = {},
	{ type, payload }
) {
	switch (type) {
		
		case "SET_USER_CURRENCY":
			//let state1 = Object.assign({}, state)
			console.log("DEBUG], SET_USER_CURRENCY", state, " >>", payload)
			return {
                ...state,
                currency: payload
            };
		
		default:
			
			return state;
	}
}
